/**
 * Rótulos das abas de formas de pagamento.
 * `full` é usado em telas maiores e `short` na versão mobile.
 * `aria` define o rótulo acessível do gatilho da aba.
 */
export const TAB_LABELS = {
  online: { full: 'PAGUE PELO APP', short: 'PELO APP', aria: 'Pague pelo app' },
  local: { full: 'PAGUE NA ENTREGA', short: 'NA ENTREGA', aria: 'Pague na entrega' },
} as const;

/**
 * Mapeamento de slugs para títulos das seções
 */
export const SECTION_TITLES = {
  online: 'Pague pelo app',
  local: 'Pague na entrega',
} as const;

/**
 * PRAT-209: variações do apelo do cartão de crédito online.
 * A agilidade foi confirmada pela pratiGO: pago online, o motoboy não passa
 * maquininha nem confere cartão/senha na porta. Não citar prazo em minutos.
 *
 * - `badge`/`benefit`/`addLabel`: bloco do cartão em "Pague pelo app".
 * - `nudge*`: aviso quando o cliente escolhe crédito/débito na entrega.
 */
export const CARD_CTA_VARIANTS = {
  a: {
    badge: 'Mais rápido',
    benefit: 'Pague pelo app e receba mais rápido',
    addLabel: 'Pagar com cartão',
    nudgeTitle: 'Pague pelo app e receba mais rápido',
    nudgeBody: 'O motoboy não para pra maquininha nem senha: entrega e segue.',
    nudgeCta: 'Cadastrar cartão agora',
  },
  b: {
    badge: 'Sem maquininha',
    benefit: 'O motoboy não para pra maquininha nem senha',
    addLabel: 'Usar meu cartão',
    nudgeTitle: 'Sem maquininha, sem senha na porta',
    nudgeBody: 'Cadastre o cartão no app e receba seu pedido mais rápido.',
    nudgeCta: 'Pagar pelo app com cartão',
  },
  c: {
    badge: 'Mais rápido',
    benefit: 'A próxima entrega rápida pode ser a sua',
    addLabel: 'Adicionar cartão',
    nudgeTitle: 'A próxima entrega rápida pode ser a sua',
    nudgeBody: 'Pagando pelo app, o motoboy não para pra maquininha nem senha.',
    nudgeCta: 'Quero receber mais rápido',
  },
} as const;

export type CardCtaVariant = keyof typeof CARD_CTA_VARIANTS;

export const CARD_SECURITY_SEAL = 'Pagamento protegido';

export const CARD_SAVED_NOTE = 'Cartão guardado com segurança para o próximo pedido';

export const CARD_NUDGE_DISMISS = 'Continuar pagando na entrega';
